module.exports = __webpack_public_path__ + "static/img/wp_logo.a938845.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wp_logo.jpg
// module id = HVOG
// module chunks = 1